<ng-container *ngIf="mediaType === 'image'">
  <img
    [src]="thumbSource || (source | resizeImage: [160, 160])"
    [alt]="alt"
    referrerpolicy="no-referrer"
    loading="lazy"
  />
</ng-container>

<ng-container *ngIf="mediaType === 'video'">
  <video [controls]="false">
    <source [src]="source" type="video/mp4" />
  </video>
  <div class="video-overlay">
    <i nz-icon nzType="play-circle" nzTheme="fill"></i>
  </div>
</ng-container>
